module.exports = __webpack_public_path__ + "static/media/07chuou.1e8a43bb.png";